import { ED_CONTEXT_MENU } from '../../ed-context-menu.plugin';

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ED_CONTEXT_MENU_DIRECTIONS } from '../../ed-context-menu.values';
import EdPresentationModeUserFilter from '@/content/components/ed-presentation-mode/ed-presentation-mode-user-filter/ed-presentation-mode-user-filter.component.vue';

@Component({
  name: 'ed-context-menu-items',
  components: { EdPresentationModeUserFilter }
})
export default class EdContextMenuItems extends Vue {

  @Prop() readonly options: any;
  @Prop() readonly orientation: any;
  @Prop({ default: false }) readonly darkMode: boolean;
  @Prop({ required: false }) readonly headerComponent: string;

  get directionClass(): string {
    return this.orientation ? ED_CONTEXT_MENU_DIRECTIONS[this.orientation].cssClass : '';
  }

  public selectOption(item) {
    if(item.disabled) 
      return;
    this.$EdContextMenu.$emit(ED_CONTEXT_MENU.EVENTS.CLOSE_CONTEXT_MENU, item);
  }
}